import React, { useState, useEffect, useRef } from 'react';
import style from './AppSettings.module.css';
import HeadSub from '../../../components/comm/HeadSub';
import SwitchBox from '../../../components/box/SwitchBox';
import URL from "../../../constants/url";
import { useNavigate } from "react-router-dom";
import Modal from "../../../components/comm/Modal"
import ImgAvatarM from "../../../images/common/i_3d_avatar_men.svg";
import ImgAvatarW  from '../../../images/common/i_3d_avatar_women.svg'
import axiosApi from '../../../api/daonAxios';
import {actionLogOut} from "../../../assets/js/comm";

/** TC_USR_ESTBS_MNG.INFO_ALRM_AT */
const ALRM_ON = '1';
const ALRM_OFF = '0';

/** 값이 없는 계정은 켜진 것으로 본다 — 가입 시 이 컬럼을 넣지 않아 비어 있을 수 있다. */
const isAlrmOn = (value) => value !== ALRM_OFF;

const AppSettings = () => {

    const navigate = useNavigate();

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const [pushToggle, setPushToggle] = useState(() => isAlrmOn(loginUser?.infoAlrmAt));

    /** 연타로 요청이 겹치지 않게 한다. */
    const isSendingRef = useRef(false);

    const handlePushToggle = async (next) => {
        if (isSendingRef.current) return;
        isSendingRef.current = true;

        const infoAlrmAt = next ? ALRM_ON : ALRM_OFF;

        setPushToggle(next); // 먼저 움직이고, 실패하면 되돌린다

        try {
            await axiosApi.post('/setting/alarm/push', { infoAlrmAt }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('jToken')}` },
            });

            // 다른 화면도 sessionStorage 의 값을 보므로 같이 맞춰준다.
            sessionStorage.setItem(
                'loginUser',
                JSON.stringify({ ...loginUser, infoAlrmAt }),
            );
        } catch (error) {
            console.error('푸시 알림 설정 변경 실패:', error);
            setPushToggle(!next);
        } finally {
            isSendingRef.current = false;
        }
    };

    //모달창
    const [isOpen, setIsOpen] = useState(false);

    const logOutBtn = () => {
        setIsOpen(!isOpen);
    }

    /**
     * 로그아웃 액션
     */
    const handleLogout = () => {
        actionLogOut(loginUser);
    };



    return (
        <>
            <HeadSub title="앱 설정" onBack={() => navigate(URL.HOME_MAIN)}/>

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">


                    <div className={style['top-box']}>
                        <div className={style['avatar-box']}>
                            <div className={style['avatar']}>
                                <object data={loginUser.gendr === '1' ? ImgAvatarM : ImgAvatarW} aria-hidden='true' />
                            </div>
                            <p>
                                <b>{loginUser?.usrNm}</b> 님
                            </p>
                        </div>
                        <button className={style['write-btn']} onClick={() => navigate(URL.MYINFO_WRITE)}>
                            <span>내 정보 수정</span>
                        </button>
                    </div>

                    <div className={style['menu-box']}>
                        <ul>
                            <li>
                                <strong>설정</strong>
                                <ul className={style['push-list-box']}>
                                    <li>
                                        <p>푸시 알림</p>
                                        <SwitchBox toggles={pushToggle} status={handlePushToggle} size="small" />
                                    </li>
                                    {/* <li onClick={() => navigate(URL.ALARM_INTENSITY)}>  
                                        <p>알림 강도 설정</p>
                                    </li> */}
                                    <li onClick={() => navigate(URL.ACTIVITY_LEVEL_CHANGE)}>
                                        <p>활동량 변경</p>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <strong>고객센터</strong>
                                <ul>
                                    <li onClick={() => navigate(URL.SERVICE_POLICY)}>서비스 약관 및 정책 </li>
                                    <li onClick={() => navigate(URL.APP_VERSION)}>앱 버전 정보 </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className={style['btn-group']}>
                                <button onClick={logOutBtn}>
                                    <span>로그아웃</span>
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 정말 로그아웃하실 건가요?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setIsOpen(false)}>
                                <span>아니오</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleLogout}>
                                <span>네</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AppSettings;
